/**
 * Respiratory charting entry (Phase 18 M8): ventilator, BiPAP/CPAP, O2, trach collar or room air.
 */

import { BaseEntryData } from './chart-entry.dto';

export const RESPIRATORY_MODES = ['VENT', 'BIPAP', 'CPAP', 'O2', 'TRACH_COLLAR', 'ROOM_AIR'] as const;
export type RespiratoryMode = typeof RESPIRATORY_MODES[number];

export const SECRETION_AMOUNTS = ['NONE', 'SMALL', 'MOD', 'LARGE'] as const;
export type SecretionAmount = typeof SECRETION_AMOUNTS[number];

export interface RespiratoryData extends BaseEntryData {
  mode: RespiratoryMode;
  ventMode?: string;
  rate?: number;
  tidalVolumeMl?: number;
  pip?: number;
  peep?: number;
  /** 21–100 */
  fio2?: number;
  o2FlowLpm?: number;
  spo2?: number;
  suctionCount?: number;
  secretionAmount?: SecretionAmount;
  secretionColor?: string;
  tolerance?: string;
  alarmsChecked?: boolean;
  circuitChecked?: boolean;
  notes?: string;
}
